import { Injectable } from "@angular/core";
import { HttpResponsesHandlersFactory } from "@bbwt/modules/data-service";
import { IQueryCommand, NumberFilter, StringFilter } from "@features/filter";
import { PagedCrudService } from "@features/grid";
import { HttpClient } from "@angular/common/http";
import { MultiUserFormAssociation, NewMultiUserFormAssociation } from "../dto/multi-user-form-associations.dto";
import { FormDataGridParameters } from "@features/bb-formio/dto/form-data";
import { SetUTCTimeZone } from "@bbwt/utils";

@Injectable()
export class MultiUserFormAssociationsService extends PagedCrudService<MultiUserFormAssociation> {
    public readonly url = "api/multi-user-form-associations";
    public readonly entityTitle = "Multi User Form Associations";
    public multiUserFormDefinitionId: number | null = null;
    public userId: string | null = null;

    constructor(http: HttpClient, handlersFactory: HttpResponsesHandlersFactory) {
        super(http, handlersFactory);
    }

    public extendQueryCommand(queryCommand: IQueryCommand) {
        queryCommand.filters = queryCommand.filters || [];
        if (this.multiUserFormDefinitionId) {
            queryCommand.filters.push(new NumberFilter("multiUserFormDefinitionId", this.multiUserFormDefinitionId));
        }
        if (this.userId) {
            queryCommand.filters.push(new StringFilter("userId", this.userId));
        }
    }

    public async addNewMUFAssociation(dto: NewMultiUserFormAssociation) {
        return await this.handleRequest<MultiUserFormAssociation>(
            this.http.post<MultiUserFormAssociation>(`${this.url}/new-mufassoc`, dto),
            this.handlersFactory.getForCreate("New Multi-User Form Association"));
    }

    public async getMUFRenderData(id: string, target: string) {
        return await this.handleRequest<MultiUserFormAssociation>(
            this.http.get<MultiUserFormAssociation>(`${this.url}/render/${id}/${target}`),
            this.handlersFactory.getDefault()
        );
    }

    public async getMufAssociationsByFormDataId(formDataId: string) {
        return await this.handleRequest<MultiUserFormAssociation>(
            this.http.get<MultiUserFormAssociation>(`${this.url}/getMufAssoc/${formDataId}`),
            this.handlersFactory.getDefault());
    }

    public async getStageCustomComponentTypes(stageId: string): Promise<number> {
        return await this.handleRequest<number>(
            this.http.get<number>(`${this.url}/stage-custom-components/${stageId}`),
            this.handlersFactory.getDefault());
    }

    async updateStageGridParameters(stageId: string, gridParams: FormDataGridParameters) {
        gridParams = {
            consultationHistoryGridFromDate: SetUTCTimeZone(gridParams.consultationHistoryGridFromDate),
            consultationHistoryGridToDate: SetUTCTimeZone(gridParams.consultationHistoryGridToDate),
            episodeNotesGridEpisodeId: gridParams.episodeNotesGridEpisodeId,
            episodeNotesGridFromDate: SetUTCTimeZone(gridParams.episodeNotesGridFromDate),
            episodeNotesGridToDate: SetUTCTimeZone(gridParams.episodeNotesGridToDate),
            medicalHistoryGridFromDate: SetUTCTimeZone(gridParams.medicalHistoryGridFromDate),
            medicalHistoryGridToDate: SetUTCTimeZone(gridParams.medicalHistoryGridToDate),
            selectedEpisodesJson: gridParams.selectedEpisodesJson
        }

        return await this.handleRequest<boolean>(
            this.http.post<boolean>(`${this.url}/stage-grid-params/${stageId}`, gridParams),
            this.handlersFactory.getDefault());

    }
}
